@if (campaignTableService.campaignDimensionInfo?.count > 0) {
  <div class="saas-ui saas-ui-size-default flex flex-1">
    <p-table
      #campaignTable
      [autoLayout]="true"
      [columns]="campaignTableService.columns"
      [lazyLoadOnInit]="false"
      [lazy]="true"
      [ngClass]="{
        'flex-1': !campaignTableService.loading,
      }"
      class="w-full"
      [resizableColumns]="true"
      scrollHeight="25rem"
      [totalRecords]="campaignTableService.campaignDimensionInfo?.count || 0"
      [value]="campaignTableService.campaignQueue.queue"
      columnResizeMode="expand"
      [tableStyle]="{ 'min-width': '100%' }"
      appendTo="body"
      tableStyleClass="p-datatable-table-lg saas-ui saas-ui-size-default taxonomy-table overflow-x-auto table-fixed">
      <ng-template pTemplate="header">
        <tr class="sticky top-0 z-[5]">
          <th scope="col" class="campaign-checkbox">
            <m-checkbox
              [disabled]="
                campaignTableService.campaignQueue.queue.length === 0 ||
                campaignTableService.selectionInProgress
              "
              [binary]="true"
              pTooltip="{{
                campaignTableService.showUpdateMappingOverlay &&
                campaignTableService.allCampaignsSelected
                  ? 'Unselect'
                  : 'Select'
              }} all {{
                campaignTableService.campaignDimensionInfo?.count || 0
              }} campaigns<br/>in this table"
              tooltipStyleClass="saas-tooltip"
              [escape]="false"
              tooltipPosition="top"
              [isChecked]="campaignTableService.allCampaignsSelected"
              [(ngModel)]="campaignTableService.allCampaignsSelected"
              (onChange)="
                campaignTableService.selectAllCampaignsInDimension($any($event))
              "></m-checkbox>
          </th>
          @for (header of campaignTableService.columns; track header.field) {
            <th
              pResizableColumn
              scope="col"
              [style.width]="header.width"
              class="{{ header.styleClass }}">
              @if (header.isFilterEnabled) {
                <lib-taxonomy-campaign-view-column-header
                  class="block w-full text-wrap"
                  [header]="header.header"
                  [headerStyle]="{
                    width: '100% !important',
                  }"
                  [filterData]="
                    campaignTableService.getColumnFilterState(header)
                  "
                  [activeTab]="campaignTableService.activeTab"
                  (searchValueChange)="
                    campaignTableService.updateCampaignsWithFilter(
                      header.field,
                      $event
                    )
                  "
                  (sortChange)="
                    campaignTableService.handleCampaignSortChange($event)
                  "></lib-taxonomy-campaign-view-column-header>
              } @else {
                {{ header.header }}
              }
            </th>
          }
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-campaign
        let-columns="columns"
        let-index="rowIndex">
        @if (campaignTableService.pageNumber > 0 && index === 0) {
          <tr>
            <td class="p-table-td-lg text-center" [colSpan]="columns.length">
              <m-link
                [label]="campaignTableService.loadPrevious"
                link="previous"
                linkElement="span"
                styleClass="b2"
                (linkClick)="
                  campaignTableService.loadMoreCampaignsFromIndexDB(
                    false,
                    campaignTable
                  )
                "></m-link>
            </td>
          </tr>
        }
        <tr>
          <td class="campaign-checkbox">
            <m-checkbox
              [value]="campaign"
              (onChange)="
                campaignTableService.updateCampaignSelection($event, campaign)
              "
              [binary]="true"
              [disabled]="
                campaignTableService.allCampaignsSelected ||
                campaignTableService.selectionInProgress
              "
              [(ngModel)]="campaign.isSelected"
              [isChecked]="
                campaign.isSelected || campaignTableService.allCampaignsSelected
              "></m-checkbox>
          </td>
          @for (header of columns; track header.field) {
            <td
              pResizableColumn
              class="{{ header.styleClass }}"
              [style.text-overflow]="'ellipsis'"
              [style.overflow]="'hidden'"
              [ngSwitch]="header.field"
              [style.width]="header.width"
              [style.height]="'4rem !important'">
              <!--#region: campaign avatar -->
              <ng-container *ngSwitchCase="'modifiedBy'">
                <div
                  class="mx-auto"
                  [pTooltip]="campaign.modifiedByTooltip"
                  [escape]="false"
                  tooltipPosition="top"
                  tooltipStyleClass="saas-tooltip">
                  <m-avatar
                    class="cursor-default"
                    [avatars]="[campaign.avatarConfig]"></m-avatar>
                </div>
              </ng-container>
              <!--#endregion -->

              <!--#region: campaign actions -->
              <ng-container *ngSwitchCase="'actions'">
                <m-button
                  type="tertiary"
                  class="p-0"
                  styleClass="p-0"
                  (click)="
                    campaignActionsMenu.toggle($event);
                    campaignTableService.setUnmapCampaignAction(
                      $event,
                      campaign
                    )
                  ">
                  <span
                    class="flex material-symbols-outlined link text-blue-600 icon-small cursor-pointer"
                    pTooltip="Modify campaign"
                    tooltipPosition="top"
                    tooltipStyleClass="saas-tooltip"
                    >more_vert</span
                  >
                </m-button>
                <p-menu
                  styleClass="mapped-campaign-actions"
                  #campaignActionsMenu
                  [popup]="true"
                  appendTo="body"
                  (onHide)="campaignTableService.clearUnmapCampaignAction()"
                  [model]="getCampaignActions()"></p-menu>
              </ng-container>
              <!--#endregion -->

              <!--#region: campaign spend -->
              <ng-container *ngSwitchCase="'spend'">
                {{
                  campaign[header.field]
                    ? (campaign[header.field] | customCurrency: "1.0-0")
                    : "-"
                }}
              </ng-container>
              <!--#endregion -->

              <!--#region: campaign impact -->
              <ng-container *ngSwitchCase="'impact'">
                <div
                  *ngIf="campaign.geoTestStatus; else noImpact"
                  class="flex items-center gap-1">
                  <span
                    class="flex material-symbols-outlined text-blue-600 text-base font-medium lh-1"
                    >info</span
                  >
                  <p class="text-gray-1000 b1 mb-0">Geo Test</p>
                </div>
                <ng-template #noImpact>-</ng-template>
              </ng-container>
              <!--#endregion -->

              <!--#region: campaign tactic -->
              <ng-container *ngSwitchCase="'tactic'">
                <ng-template [ngTemplateOutlet]="tacticColumn"></ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'operationalTactic'">
                <ng-template [ngTemplateOutlet]="tacticColumn"></ng-template>
              </ng-container>
              <ng-template #tacticColumn>
                <span
                  [@fadeIn]="campaignTableService.showAiRecommendations"
                  class="cursor-pointer"
                  [pTooltip]="
                    campaign['recommendedTactic'] &&
                    campaignTableService.showAiRecommendations
                      ? campaign['tacticAiTooltip']
                      : campaign['tacticTooltip']
                  "
                  [escape]="false"
                  tooltipPosition="top"
                  tooltipStyleClass="saas-tooltip">
                  <span
                    [ngClass]="{
                      'text-gray-800':
                        campaignTableService.showAiRecommendations &&
                        campaign['recommendedTactic'],
                    }"
                    >{{
                      campaignTableService.showAiRecommendations &&
                      campaign["recommendedTactic"]
                        ? campaign["recommendedTactic"]
                        : campaign[header.field] || "-"
                    }}</span
                  >
                </span>
              </ng-template>

              <ng-container *ngSwitchCase="'channel'">
                <ng-template [ngTemplateOutlet]="channelColumn"></ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'operationalChannel'">
                <ng-template [ngTemplateOutlet]="channelColumn"></ng-template>
              </ng-container>
              <ng-template #channelColumn>
                <span
                  [@fadeIn]="campaignTableService.showAiRecommendations"
                  class="cursor-pointer"
                  [pTooltip]="
                    campaign['recommendedChannel'] &&
                    campaignTableService.showAiRecommendations
                      ? campaign['channelAiTooltip']
                      : campaign['channelTooltip']
                  "
                  [escape]="false"
                  tooltipPosition="top"
                  tooltipStyleClass="saas-tooltip">
                  <span
                    [ngClass]="{
                      'text-gray-800':
                        campaignTableService.showAiRecommendations &&
                        campaign['recommendedChannel'],
                    }"
                    >{{
                      campaignTableService.showAiRecommendations &&
                      campaign["recommendedChannel"]
                        ? campaign["recommendedChannel"]
                        : campaign[header.field] || "-"
                    }}</span
                  >
                </span>
              </ng-template>

              <ng-container *ngSwitchCase="'segment'">
                <ng-template [ngTemplateOutlet]="segmentColumn"></ng-template>
              </ng-container>
              <ng-container *ngSwitchCase="'operationalSegment'">
                <ng-template [ngTemplateOutlet]="segmentColumn"></ng-template>
              </ng-container>
              <ng-template #segmentColumn>
                <span
                  [@fadeIn]="campaignTableService.showAiRecommendations"
                  class="cursor-pointer"
                  [pTooltip]="
                    campaign['recommendedSegment'] &&
                    campaignTableService.showAiRecommendations
                      ? campaign['segmentAiTooltip']
                      : campaign['segmentTooltip']
                  "
                  [escape]="false"
                  tooltipPosition="top"
                  tooltipStyleClass="saas-tooltip">
                  <span
                    [ngClass]="{
                      'text-gray-800':
                        campaignTableService.showAiRecommendations &&
                        campaign['recommendedSegment'],
                    }"
                    >{{
                      campaignTableService.showAiRecommendations &&
                      campaign["recommendedSegment"]
                        ? campaign["recommendedSegment"]
                        : campaign[header.field] || "-"
                    }}</span
                  >
                </span>
              </ng-template>
              <!--#endregion-->
              <!--#region: ai icon -->
              <ng-container *ngSwitchCase="'mappedBy'">
                <m-tooltip
                  styleClass="flex justify-center relative"
                  content="<img
                    alt='AI Sparkles'
                    src='assets/images/sparkles.svg'
                    width='20px'
                    height='20px'
                    class='pe-1' /> Mapped by AI
                ">
                  <span class="p-2.5">
                    <img
                      alt="AI Sparkles"
                      src="assets/images/sparkles.svg"
                      width="20px"
                      height="20px" />
                  </span>
                </m-tooltip>
              </ng-container>
              <!--#endregion-->

              <ng-container *ngSwitchDefault>
                <span
                  [pTooltip]="
                    (campaign[header.field] + '').length > 30
                      ? campaign[header.field]
                      : ''
                  "
                  tooltipStyleClass="saas-tooltip"
                  tooltipPosition="top"
                  class="block max-h-full overflow-hidden overflow-ellipsis text-wrap break-words">
                  {{ campaign[header.field] || "-" }}
                </span>
              </ng-container>
            </td>
          }
        </tr>
        @if (
          index === campaignTableService.campaignQueue.queue.length - 1 &&
          campaignTableService.activeDimensionPageNumber <
            campaignTableService.campaignDimensionInfo.count /
              campaignTableService.virtualPageSize -
              1 &&
          campaignTableService.campaignDimensionInfo?.count >= 100
        ) {
          <ng-container>
            <tr>
              <td class="p-table-td-lg text-center" [colSpan]="columns.length">
                <m-link
                  [label]="campaignTableService.loadNext"
                  link="next"
                  linkElement="span"
                  styleClass="b2"
                  (linkClick)="
                    campaignTableService.loadMoreCampaignsFromIndexDB(
                      true,
                      campaignTable
                    )
                  "></m-link>
              </td>
            </tr>
          </ng-container>
        }
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <!--#region: table loading skeleton -->
        <div>
          @if (campaignTableService.loading) {
            @for (i of [1, 2, 3, 4, 5]; track i) {
              <tr>
                <td
                  [style.width]="'4rem'"
                  class="campaign-checkbox leading-none">
                  <p-tableCheckbox [disabled]="true"></p-tableCheckbox>
                </td>
                @for (
                  header of campaignTableService.columns;
                  track header.field
                ) {
                  <td
                    class="p-table-td-lg {{ header.styleClass }} leading-none"
                    [style.width]="header.width"
                    [style.max-width]="header.width"
                    [style.min-width]="header.width">
                    <p-skeleton
                      styleClass="block tw-w-full"
                      height="2rem"
                      width="100%"></p-skeleton>
                  </td>
                }
              </tr>
            }
          } @else {
            <tr>
              <td colspan="100%">
                <m-not-available
                  [noDataState]="campaignTableService.noData"
                  [title]="'No campaigns within this group'"></m-not-available>
              </td>
            </tr>
          }
        </div>
        <!--#endregion -->
      </ng-template>
    </p-table>
  </div>
}
